// extracted by mini-css-extract-plugin
export default {"ppe-icon-actions":"Sites_ppe-icon-actions__NztfM","edit":"Sites_edit__ZUHkW","delete":"Sites_delete__bu9Jp"};